var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isAdminSite, isWebView } from '../helpers';
export var mixpanelIdentityPath = {
    companyUrl: ['@@store.auth.company.url', window.location.host],
    companyName: ['@@store.auth.company.id'],
    userId: ['@@store.auth.id'],
    projectType: isAdminSite() ? 'Admin' : 'WebLearner',
    inWebView: isWebView(),
    orgId: ['@@store.auth.company.orgId'],
    superlogin: ['@@store.auth.superlogin'],
    companyType: ['@@store.auth.company.companyType'],
};
var globalMixpanelIdentity = {
    moduleName: {
        name: 'module_name',
    },
    moduleType: {
        name: 'module_type',
    },
    moduleId: {
        name: ['module_id'],
    },
    seriesId: {
        name: 'series_id',
    },
    seriesName: {
        name: 'series_name',
    },
    companyUrl: {
        name: 'learning_site',
    },
    companyName: {
        name: 'cname',
    },
    userId: {
        name: 'user_id',
    },
    projectType: {
        name: 'project_type',
    },
    orgId: {
        name: 'org_id',
    },
    superlogin: {
        name: 'superlogin',
    },
    companyType: {
        name: 'learning_site_type',
    },
    assetType: {
        name: 'asset_type',
    },
    inWebView: {
        name: 'in_web_view',
    },
    zoom_integration_enabled: {
        name: 'zoom_integration_enabled',
    },
};
export var mixpanelIdentity = {
    set: function (identity) {
        globalMixpanelIdentity = __assign(__assign({}, globalMixpanelIdentity), identity);
    },
    get: function () { return globalMixpanelIdentity; },
};
//# sourceMappingURL=index.js.map